import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const RedoIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.8252 11.0462L13.819 14.1128L14.622 14.9334L19 10.4667L14.6242 6L13.8202 6.82055L16.8252 9.88719H10.2462C9.42595 9.88719 8.61372 10.0521 7.85589 10.3724C7.09807 10.6928 6.40949 11.1623 5.82947 11.7542C5.24946 12.3461 4.78937 13.0488 4.47547 13.8222C4.16156 14.5956 4 15.4244 4 16.2615V18H5.13568V16.2615C5.13568 15.5766 5.26786 14.8985 5.52469 14.2657C5.78152 13.6329 6.15796 13.058 6.63252 12.5737C7.10708 12.0894 7.67046 11.7053 8.2905 11.4432C8.91054 11.1811 9.57509 11.0462 10.2462 11.0462H16.8252Z"
            fill="currentColor"/>
    </svg>

)
const RedoIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {RedoIconSvg}
    </SvgIcon>
);
export default RedoIcon